import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function CTASection() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      headline: 'Ready To Wear Your Story?',
      subhead: "Limited appointments available in Miami. Reach out and let's create something eternal.",
      btn1: '📱 WhatsApp: +1 (305) 725-6699',
      btn2: '📷 Instagram: @krlygoldtattoo',
      footer: 'Black & White Realism | Tattooing Since 2018'
    },
    es: {
      headline: '¿Listo Para Llevar Tu Historia?',
      subhead: 'Citas limitadas disponibles en Miami. Escríbeme y creemos algo eterno juntos.',
      btn1: '📱 WhatsApp: +1 (305) 725-6699',
      btn2: '📷 Instagram: @krlygoldtattoo',
      footer: 'Realismo Blanco y Negro | Tatuando Desde 2018'
    }
  };
  const t = content[language];
  return <section className="relative min-h-screen flex items-center justify-center py-24 px-6 overflow-hidden" data-id="element-25">
      <div className="absolute inset-0 bg-gold-glow opacity-60" data-id="element-26" />

      <div className="relative z-10 flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-27">
        <motion.h2 className="text-5xl md:text-7xl font-serif text-brand-gold mb-6" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-28">
          {'\xBFListo Para Llevar tu Historia a la piel?'}
        </motion.h2>

        <motion.p className="text-lg md:text-xl text-brand-white font-sans font-light mb-12 max-w-2xl" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-29">
          {t.subhead}
        </motion.p>

        <motion.div className="flex flex-col sm:flex-row gap-6 w-full justify-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-30">
          <a href="https://wa.me/13057256699" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto py-5 px-10 bg-brand-gold text-brand-black font-serif text-lg md:text-xl tracking-widest uppercase transition-all duration-300 hover:bg-brand-gold-light hover:shadow-[0_0_20px_rgba(201,168,76,0.4)]" data-id="element-31">
            {t.btn1}
          </a>
          <a href="https://instagram.com/krlygoldtattoo" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto py-5 px-10 border border-brand-gold text-brand-gold font-serif text-lg md:text-xl tracking-widest uppercase transition-all duration-300 hover:bg-brand-gold hover:text-brand-black" data-id="element-32">
            {t.btn2}
          </a>
        </motion.div>

        <motion.div className="text-brand-white/70 font-sans text-xs md:text-sm tracking-widest uppercase space-y-2" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-33">
          <p data-id="element-34">📍 Miami, FL | Tattoo Studio</p>
          <p data-id="element-35">{t.footer}</p>
        </motion.div>
      </div>
    </section>;
}